import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=4ece1050&scoped=true&"
import script from "./CardHeader.vue?vue&type=script&lang=js&"
export * from "./CardHeader.vue?vue&type=script&lang=js&"
import style0 from "./CardHeader.vue?vue&type=style&index=0&id=4ece1050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece1050",
  null
  
)

export default component.exports